import { getEnv } from "../../../../../utils/env"
import has from "mout/object/has"
import queryString from "query-string"
import { db, firestore, FirestoreTimestamp } from "../../../../mp-database"
import { addExtraData } from "."
import { getSchoolYear } from "../../../../mp-utils/generic-utils"
import axios from "axios"

const fetchUserAssessment = async (
  user,
  assessmentId,
  schoolYear,
  success,
  setUserAssessments,
  error,
  assessmentSets
) => {
  // const scoringPromises = []
  // const userAssessments = {}
  // const userAssessmentDocs = await db
  //   .collection("userAssessments")
  //   .where("userId", "==", user.id)
  //   .get()
  //   .then(uADocs => parseSnapshot(uADocs))

  // const userAssessmentDocChunks = chunk(Object.values(userAssessmentDocs), 10)

  // userAssessmentDocChunks.forEach(userAssessmentDocChunck => {
  //   const userAssessmentDoc = userAssessmentDocs[userAssessmentIdChunk[0]]

  // })

  // for (let uAId in userAssessmentDocs) {
  //   const uA = userAssessmentDocs[uAId]
  //   if (uA.assessmentId && uA.year) {
  //     const key = `${uA.assessmentId}_${uA.userId}_${uA.year}`
  //     userAssessments[key] = uA
  //   }
  // }

  const userAssessmentId = (() => {
    if (user.assessments[assessmentId]) {
      const userAssessmentId = user.assessments[assessmentId]
      const useSchoolYear = getEnv('USE_SCHOOL_YEAR')?.trim().toLowerCase()
      if( useSchoolYear === 'false' ) {
        const years = Object.keys(userAssessmentId).filter(a => Boolean(a)).sort((a,b) => Number(b)-Number(a))
        if( years.length > 0 ) {
          return userAssessmentId[years[0]].userAssessmentId
        }
      }
      if (userAssessmentId.hasOwnProperty(schoolYear)) {
        const userAssessmentId =
          user.assessments[assessmentId][schoolYear].userAssessmentId
        return userAssessmentId
      }
    }
    return null
  })()
  if( userAssessmentId ) {
    return db
      .collection("userAssessments")
      .doc(userAssessmentId)
      .get()
      .then(async userAssessmentDoc => {
        const userAssessment = userAssessmentDoc.data()
        if (!userAssessment || !userAssessment.assessmentSetId) {
          return null
        }

        const uA = await addExtraData(userAssessment)
        success(uA)
        return uA
      })
      .catch(err => error(err))
  }
  return null
}

export default async function initializeAssessment(
  assessmentId,
  studentId,
  user,
  search,
  { loading, success, error, setUserAssessments },
  assessmentSets
) {
  const userId = user.id
  const role = user.role

  let currentSchoolYear = Number(getSchoolYear().year)
  //Initiate new records using school year
  let schoolYear = currentSchoolYear

  // When role is admin, the selected student id is indicated
  // by "s" in the query (if there is a selected student).
  // There is only a selected student if the user has drilled down
  // from the class level all the way down to the student level
  // in the selector box.
  let selectedStudent = ""
  if (search) {
    const qs = queryString.parse(search)
    if (has(qs, "s")) {
      selectedStudent = qs.s
    }
    if (has(qs, "y")) {
      schoolYear = Number(qs.y)
    }
  }
  // Does this if we are looking at an individual student's data.
  // We know this if the user role is "Student", if the user role
  // is an educator and there is a selectedStudent in the query,
  // or if studentId was passed into this function.
  if ((role === "Student" || studentId || selectedStudent) && assessmentId) {
    const set = await db
      .collection("sets")
      .doc(assessmentId)
      .get()
      .then(doc => {
        const setDoc = doc.data()
        if (doc.exists && !setDoc.deleted) {
          return setDoc
        }
      })

    if (!set) return

    loading()
    let docId = userId
    if (studentId || selectedStudent) {
      docId = studentId || selectedStudent
    }

    return db
      .collection("students")
      .doc(docId)
      .get()
      .then(async userDoc => {
        const user = userDoc.data()
        // if this assessment exists in the user's record, fetch the corresponding
        // userAssessment. (This userAssessment stores all of the data about a
        // specific user's interactions with one assessment.)
        if (!user.assessments) user.assessments = {}

        const uA = await fetchUserAssessment(
          user,
          assessmentId,
          schoolYear,
          success,
          setUserAssessments,
          error,
          assessmentSets
        )
        if (uA) return

        //If this assessment does not exist in the user's record, initialize an
        //empty userAssessment for this user corresponding to this assessment.
        if (
          !user.initializingAssessments &&
          (!user.assessments ||
            !has(user, `assessments.${assessmentId}`) ||
            !user.assessments[assessmentId][schoolYear]) &&
          assessmentId
        ) {
          axios
            .post(
              `${getEnv(
                "CLOUD_FUNCTION_ROOT"
              )}/assessmentGroup-initTruScoreAssessment`,
              {
                student: user,
                forceInit: role !== "Student" ? true : false,
                assessmentId
              },
              {
                headers: {
                  "Content-Type": "application/json"
                }
              }
            )
            .then(async response => {
              if (response && response?.data.success) {
                const { student, initializedAssessments } = response.data.data

                if (initializedAssessments.length) {
                  let uA = initializedAssessments.filter(
                    userAssessment =>
                      userAssessment.assessmentSetId === assessmentId
                  )[0]

                  uA = await addExtraData(uA)
                  success(uA, student)
                } else {
                  error({
                    error: `No assessment was initialized for student_id: ${student.id}`
                  })
                }
              } else {
                error({
                  error: `Error occurred while initiating user assessment`
                })
              }
            })
            .catch(err => {
              console.log(err)
              error({
                error: `Error occurred while initiating user assessment: ${err}`
              })
            })
        } else if (user.initializingAssessments) {
          const url = `${getEnv(
            "CLOUD_FUNCTION_ROOT"
          )}/miscGroup-serverTimestamp`
          const res = await axios.get(url)

          if (res.data.success) {
            const currentServerTimestamp = res.data.timestamp._milliseconds
            const initTimestamp = user.initializingAssessmentsTimeStamp
              ?._seconds
              ? new FirestoreTimestamp(
                  user.initializingAssessmentsTimeStamp._seconds,
                  user.initializingAssessmentsTimeStamp._nanoseconds
                )
              : user.initializingAssessmentsTimeStamp
            const diff =
              currentServerTimestamp - (initTimestamp?.toMillis() ?? 0)

            if (diff && diff > 20 * 1000) {
              await db.collection("students").doc(user.id).update({
                initializingAssessments: false,
                initializingAssessmentsTimeStamp:
                  firestore.FieldValue.serverTimestamp()
              })

              console.log(`Assessment initialization timeout, forcing re-init`)
              return initializeAssessment(
                assessmentId,
                studentId,
                user,
                search,
                { loading, success, error, setUserAssessments },
                assessmentSets
              )
            }
          }

          let unsubscribe = db
            .collection("students")
            .doc(user.id)
            .onSnapshot(
              async snapshot => {
                let snapShotData = snapshot.data()
                if (!snapShotData.initializingAssessments) {
                  await fetchUserAssessment(
                    snapShotData,
                    assessmentId,
                    schoolYear,
                    success,
                    setUserAssessments,
                    error,
                    assessmentSets
                  )
                  unsubscribe()
                }
              },
              err => {
                error(err)
                console.log(err)
              }
            )
        }
      })
      .catch(err => {
        console.log(err)
        error(err)
      })
  }
}
